import { Stack } from 'components';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { getLsUserRoleObject } from 'modules/networkTools/localStorageTokens';
import { useAppDispatch } from 'store/hooks';
import { getBillingConfig } from 'store/clientProfile/clientProfileActions';
import { useEffect } from 'react';

import { ClientFormWrapper } from '../clientForm/clientForm';
import { ClientFormWrapper as NewClientFormWrapper } from '../clientForm/newClientForm';
import { Profile } from '../clientForm/profile';

const MobileClientForm = () => {
  const { enableBillingUpdates } = useFlags();
  const { organizationId } = getLsUserRoleObject();
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (enableBillingUpdates) {
      dispatch(getBillingConfig({ organizationId }));
    }
  }, []);

  if (enableBillingUpdates) {
    return (
      <NewClientFormWrapper>
        <Stack padding="8px">
          <Profile />
        </Stack>
      </NewClientFormWrapper>
    );
  }

  return (
    <ClientFormWrapper>
      <Stack padding="8px">
        <Profile />
      </Stack>
    </ClientFormWrapper>
  );
};

export default MobileClientForm;
